export enum InviteesGroupEnums {
  UPLOAD_LIST = 'upload_list',
}
